import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { TokenStorage } from '../../core/token.storage';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
constructor(private router: Router, private authService: AuthService, private token: TokenStorage, private toastr: ToastrService) { 
    if (this.token.getToken() != null) {
           
            this.router.navigate(['admin/statistique']); 
           
    }
}
  login: string;
  password: string;
  loginForm: FormGroup;

    ngOnInit() {
        this.createForm();
    }

    private createForm() {
        this.loginForm = new FormGroup({
            // tslint:disable-next-line
            login: new FormControl('', [Validators.required, Validators.pattern('')]),
            password: new FormControl('', Validators.required),
        });
    }

    loginUp(): void {
        this.authService.attemptAuth(this.login, this.password).subscribe(
            data => {
                if(data.admin === true){
                    this.token.saveToken(data.token);
                    this.token.saveUserProfile("ADMIN");
                    this.router.navigate(['admin/statistique']);
                    this.showSuccess();
                }else{
                    this.token.removeToken()
                    this.showError();
                }
                
            },
            (err) => {
                this.showError();
            }
        );
    }

    // For Toatr. 
    showSuccess() {
        this.toastr.success('Connexion éffectuée avec succès!', 'Connexion');
    }
    // For Toatr. 
    showError() {
        this.toastr.error('Login ou mot de passe incorrect!', 'Erreur de connexion!');
    }
}



// WEBPACK FOOTER //
// ./src/app/admin-app/login/login.component.ts